module.exports = require('react/lib/shallowCompare');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-shallow-compare/index.js
 ** module id = ./node_modules/react-addons-shallow-compare/index.js
 ** module chunks = 1
 **/